import React from "react";
import { Box, Text } from "@chakra-ui/react";
import Balancer from "@hightouchio/react-wrap-balancer";
import { Paragraph } from "./paragraph";
import { ButtonGroup } from "./button-group";
export function EmptyState({ imageUrl, title, message, actions, ...props }) {
    return (React.createElement(Box, { ...props, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", border: "1px", borderColor: "base.border", borderRadius: "md", py: 16 },
        imageUrl && React.createElement(Box, { as: "img", src: imageUrl, maxHeight: 48 }),
        title && (React.createElement(Text, { mt: imageUrl ? 6 : 0, fontSize: "lg", fontWeight: "semibold", lineHeight: "6" }, title)),
        React.createElement(Box, { mt: 1, maxWidth: "md", mx: "auto" },
            React.createElement(Paragraph, { textAlign: "center" },
                React.createElement(Balancer, { ratio: 0.65 }, message))),
        actions && React.createElement(ButtonGroup, { mt: 6 }, actions)));
}
